import { APIClient } from '@/data/APIClient'

export class ProfileAction {
  /**
   * Update the current user's profile.
   * @param firstName First name
   * @param lastName Last name
   * @param birthday Birthday in Y-m-d format (may be empty)
   */
  static update (firstName: string, lastName: string, birthday: string) {
    return APIClient.client.post('/profile/update', {
      first_name: firstName,
      last_name: lastName,
      birthday: birthday
    })
  }

  /**
   * Pull the current user's profile from Mailchimp and apply it in the backend.
   * Used as a manual fallback when the Mailchimp webhook doesn't fire.
   */
  static sync () {
    return APIClient.client.post('/profile/sync', {})
  }
}
